import React, { useState, useEffect } from 'react';
import { getGallery, resolveAssetUrl } from '../services/api';
import { Dialog, DialogContent, DialogTrigger } from './ui/dialog';

const Gallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getGallery();
        setGalleryImages(data);
      } catch (error) {
        console.error('Error fetching gallery:', error);
      }
    };
    fetchData();
  }, []);

  return (
    <section id="gallery" className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2
            className="md:text-6xl !font-bold !text-5xl mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}>Galería


          </h2>
          <p className="max-w-2xl !text-lg mx-auto text-gray-600">Una vista a nuestro arte culinario y nuestro elegante ambiente

          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((image) =>
          <Dialog key={image.id}>
              <DialogTrigger asChild>
                <div
                className="relative overflow-hidden rounded-lg cursor-pointer group h-64"
                onClick={() => setSelectedImage(image)}>

                  <img
                  src={resolveAssetUrl(image.url)}
                  alt={image.alt}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" />

                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300" />
                </div>
              </DialogTrigger>
              <DialogContent className="max-w-4xl">
                <img
                src={resolveAssetUrl(image.url)}
                alt={image.alt}
                className="w-full h-auto rounded-lg" />

              </DialogContent>
            </Dialog>
          )}
        </div>
      </div>
    </section>);

};

export default Gallery;